import { createStore, useStore } from 'zustand';
import { createContext, useContext } from 'react';
import {
  NEXT_PUBLIC_ENV,
  NEXT_PUBLIC_ENV_VARIANT,
  getEnvVariable
} from 'src/utils/envVariablesHelper';

interface Props {
  hostURL: string;
}
interface State extends Props {
  setHostURL: (hostURL: string) => void;
}

type Store = ReturnType<typeof createHostStore>;

export const createHostStore = (
  initProps: Props,
  locale: string,
  defaultLocale: string
) => {
  const protocol =
    getEnvVariable(NEXT_PUBLIC_ENV) === NEXT_PUBLIC_ENV_VARIANT.DEV
      ? 'http'
      : 'https';
  const url = `${protocol}://${initProps.hostURL}/${
    locale === defaultLocale ? '' : locale
  }`;

  return createStore<State>()((set) => ({
    hostURL: initProps?.hostURL ? url : undefined,
    setHostURL: (hostURL) => set({ hostURL })
  }));
};

export const HostStoreContext = createContext<Store | null>(null);

const useHostStore = () => {
  const store = useContext(HostStoreContext);

  const hostURL = useStore(store, (s) => s.hostURL);
  const setHostURL = useStore(store, (s) => s.setHostURL);

  return {
    hostURL,
    setHostURL
  };
};

export default useHostStore;
